import http from '../utils/http'
export function postRegister (params) {
  return http.post('/register', params)
}

export function postLogin (params) {
  return http.post('/user/login', params)
}

export function postDunheLogin (params) {
  return http.post('/user/dunhe_login', params)
}



// WEBPACK FOOTER //
// ./src/api/login.js